import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

type DeleteAssignmentParams = OpalApiRequestParams<'DeleteAssignmentV2'>

export const deleteAssignment = async ({
  params,
}: {
  params: DeleteAssignmentParams
}) => {
  const url = new URL(
    `/workflows/v2/assignments/${params.path.assignment_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then((res) => res.data)
}
